import React, { Component, forwardRef } from "react";
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import InsertLinkIcon from '@material-ui/icons/InsertLink';
import axios from "axios";
import { ListItemAvatar, Typography } from "@material-ui/core";
import PrivateComponent from "../Component2/PrivateComponent";
import WS from "../../Config/WS";
import Tabela from "../Tabela/Tabela";
import { withRouter } from "react-router-dom";
import Tabela2, {ITableQuery} from "../Tabela/Tabela2";
import Formatter from "../../utils/Formatters";
import ScheduleIcon from '@material-ui/icons/Schedule';
import NocRequest from "../../utils/NocRequest";
import { ILojas } from "../../persistence/interfaces/ILojas";
import { connect } from "react-redux";
import { AppState } from "../../reducer/ReducerTypes";

const tableIcons: any = {
    Add: forwardRef((props, ref:any) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref:any) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref:any) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref:any) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref:any) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref:any) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref:any) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref:any) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref:any) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref:any) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref:any) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref:any) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref:any) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref:any) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref:any) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref:any) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref:any) => <ViewColumn {...props} ref={ref} />),
    AddCliente: forwardRef((props, ref:any) => <AddCircleIcon {...props} ref={ref} />),
};

const consulta = (query: ITableQuery) => {
    let order = (query?.orderBy?.field || 'ultima_atualizacao') + ' ' + (query?.orderDirection || 'desc');
    let search: string = query?.search || '';
    let field: string = query?.field || '';
    let where: string = "";
    //console.log(query)
    where = field == "" ? `
        where  false
        or upper(empresa) like '%${search.toUpperCase()}%'
        or upper(codigo) like '%${search.toUpperCase()}%'
        or upper(filial) like '%${search.toUpperCase()}%'
        or upper(nome) like '%${search.toUpperCase()}%'
    ` : `
        where  ${field} like '%${search.toUpperCase()}%'
    `;

    return new Promise<any>(async(resolve, reject) => {
        let result: any = await axios.post(WS.URL_NOC + "entity/sqlpage", {
            sql: `
                select * from (
                    select l.*, case when lic.ativo then 'Ativa' else 'Inativa' end as licenca
                    from lojas l
                    left join nfes_licencas lic on lic.cnpj = l.cnpj
                    ) as con
                    ${where}
                order by ${order}               
            `,
            page: query.page,
            pageSize: query.pageSize,
            search: query.search,
            orderBy: ""
        })
        resolve({
            data: result?.data?.data,
            page: result?.data?.page-1,
            totalCount: result?.data?.total
        });
    })   
}
interface IProps {
    selecao?: boolean;
    appstate: AppState;
    SetClienteVenda: (codigocliente: number, nome: string) => void;
}
class Lojas extends PrivateComponent<IProps, any> {
    constructor(props: any) {
        super(props);
        this.rowClick = this.rowClick.bind(this);
        this.addAtualizacao = this.addAtualizacao.bind(this);
        this.showAtualizadorAutomatico = this.showAtualizadorAutomatico.bind(this);
    }
    componentDidMountPrivate() {

    }
    rowClick(event: any, rowData: any) {
        //RowClick(event, rowData, this.props.doError);
    }
    addAtualizacao(row: ILojas) {
        if (this.props.appstate.login.gruposUsuario.indexOf('noc') >= 0) {
            this.showConfirm(`Tem certeza que deseja gerar um agendamento de atualização automática para essa loja ?`, async () => {
                await NocRequest.execSql(`
                    insert into nocatualizador (empresa, loja, cnpj, ativo)
                    values 
                    ('${row.empresa}', '${row.codigo}', '${row.cnpj}', 0)
                `);
            });
        }
        else {
            this.showAlert("Usuário sem acesso a essa operação");
        }
    }
    async showAtualizadorAutomatico(row: any) {
        let data = Buffer.from(`${row.empresa}-${row.cnpj}`).toString("base64");
        this.showAlert([
            "Para instalar o atualizador automático execute o comando abaixo no terminal do servidor (como usuário root):",
            `bash <(curl -s http://nocstatic.wcompany.com.br/install/?data=${data})`
        ], undefined, "lg");
    }
    renderPrivate() {
        return (
            <div style={{ maxWidth: "100%", width: '100%' }}>
                <Tabela2
                    //icons={tableIcons}
                    actions={[
                        {
                            icon: <InsertLinkIcon />,
                            isFreeAction: false,
                            tooltip: "Instalar do Atualizador Automático",
                            onClick: (row: any) => {
                                this.showAtualizadorAutomatico(row);
                            }
                        },
                        ...[(this.props.appstate.login.gruposUsuario.indexOf('noc') == -1 ? {} as any :
                        {
                            icon: <ScheduleIcon />,
                            isFreeAction: false,
                            tooltip: "Adicionar um agendamento de atualização automática",
                            onClick: (row: any) => {
                                this.addAtualizacao(row);
                            }
                        })],
                    ]}
                    columns={[
                        { title: "Empresa", field: "empresa" },
                        { title: "Codigo", field: "codigo" },
                        { title: "CNPJ", field: "cnpj" },
                        { title: "Filial", field: "filial" },
                        { title: "Nome", field: "nome" },
                        { title: "Últ.Sincronia", field: "ultima_atualizacao", type: "date", render: Formatter.date("ultima_atualizacao", "d/m/Y h:n") },
                        { title: "Licença", field: "licenca" },
                        
                    ]}
                    fieldsSelect={[
                        "empresa", "codigo", "cnpj", "filial"
                    ]}
                    data={consulta}
                    pageSize={30}
                    orderByField="ultima_atualizacao"
                    orderByDirection="desc"
                    /*options={{
                        searchFieldAlignment: 'right',
                        minBodyHeight: 'calc(100vh - 200px)',
                        maxBodyHeight: 'calc(100vh - 200px)',
                        pageSize: 30,
                        pageSizeOptions: [9, 20, 30, 50, 100],
                        search: true,
                    }}
                    search2={true}*/
                    search={true}
                    // onSearchChange={(txt: string) => { console.log(txt); }}
                    // onQueryChange={() => { console.log('query changed') }}

                    title="Listagem de Lojas"
                    subtitle="Lista de lojas que realizam transmissões para o NOC"
                    /*onRowClick={this.rowClick}
                    localization={{
                        header: {
                            actions: ""
                        }
                    }}*/
                    actionBarFreeWidth={2}
                    actionsColumns={2}
                    actionColumnWidth={25}
                    
                />

                {this.baseRender()}
            </div>
        );
    }
}

const mapStateToProps = (state: AppState, ownProps: any) => {
    return {appstate: state};
}
const mapDisptachToProps = (dispatch: any, ownProps: any) => {
    return {
        ...ownProps,
    };
}

export default connect(mapStateToProps, mapDisptachToProps)(Lojas);